import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AM from './TabComponents/AM';
import Mid from './TabComponents/Mid';
import API_PATH from "../../../constants/config.json";
import PM from './TabComponents/PM';
import CircularProgress from '@material-ui/core/CircularProgress';
import Cookies from 'js-cookie';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

//Start Css Code ....
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '165px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },
    '& h5': {
      fontSize: '16pt',
      margin: '0px',
    }
  },
  Intersection: {
    padding: '5px',
    height: '100%',
    width: '100%',
    float: 'left',
    background: '#fff',
    top: '2%',
    zIndex: '1',
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .trafficCountsSelect': {
      padding: '5px',
      color: '#333',
      paddingRight: '20px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '12pt',
        width: '275px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '22pt',
        width: '500px',
      },
    }
  },
  tabblock: {
    border: '1px solid #24618E',
    paddingTop: '0px',
    marginBottom: '10px',
    borderRadius: '5px 5px 5px 5px',
    width: '100%',
    float: 'left',   
    overflowY: 'scroll',
    '& .MuiBox-root': {
      padding: '0px 10px 10px 10px',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    }
  },
  appBarMain: {
    paddingLeft: '35%',
    marginTop: '-25px',
  },
  tableHead: {
    fontWeight: 'normal',
    fontSize: '14pt',
    textAlign: 'center',
    color: '#333',
    padding: 0,
  },
  titleTD: {
    textAlign: 'left',
    fontSize: '18px',
    padding: 0
  },
  dataTD: {
    textAlign: 'center',
    fontSize: '18px',
    padding: 0
  },
  tableContent: {
    width: '60%',
  },
  tableMidBlock: {
    marginTop: '10px',
    '& td': {
      border: '1px solid #D7D7D7',
      padding: '5px'
    },
    '& th': {
      border: '1px solid #D7D7D7',
      padding: '5px',
    },
  },
  tabDisable: {
    // border: '1px solid #999999',
    backgroundColor: '#ffffff',
    color: '#666666',
    border: '1px solid grey',
    opacity: 0.5,
  },
  tabDivMain: {
  }
}));
//End Css Code ....

//Start IntersectionTrafficCounts component code ...
const IntersectionTrafficCounts = props => {
  let activeTab = sessionStorage.getItem('activeIntTrafficCountTab') ? parseInt(sessionStorage.getItem('activeIntTrafficCountTab')) : 0;//set active tab index from session to retain tab on refresh
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(activeTab);
  const [getDropDate, setDropDate] = React.useState([]);
  const [getTrafficCount, setTrafficCount] = React.useState([]);
  const [getSelectedDate, setSelectedDate] = React.useState('');
  const [AMdata, setAMdata] = React.useState(null);
  const [MIDdata, setMIDdata] = React.useState(null);
  const [PMdata, setPMdata] = React.useState(null);
  const [peakData, setPeakData] = React.useState();
  const [peakDate, setPeakDate] = React.useState();
  const [selectedDate, setSelectedDates] = React.useState([]);
  const [dateVal, setDateVal] = React.useState([]);

  const [getAMDisabled, setAMDisabled] = React.useState(false);
  const [getPMDisabled, setPMDisabled] = React.useState(false);
  const [getMIDDisable, setMIDDisable] = React.useState(false);
  const [getLoader, setLoaderDisable] = React.useState(false);

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

  const handleChange = (event, newValue) => {
    sessionStorage.setItem('activeIntTrafficCountTab', newValue);//set active tab index in session to retain tab on refresh
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    sessionStorage.setItem('activeIntTrafficCountTab', index);//set active tab index in session to retain tab on refresh
    setValue(index);
  };

  React.useEffect(
    () => {
      if (props.stationId) {
        getIntersectionDatePeakData();
      }
    }, [props.stationId]
  );

  const getStationDetailData = () => {
    setLoaderDisable(true);
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getIntersectionDatePeakData,
        data: {
          stationId: props.stationId,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          setLoaderDisable(false);
          let tempPeakArr = [];
          let data = response.data.data;
          setTrafficCount(data);
          response.data.data.map((ele, index) => {

            let date = new Date(ele.date);
            const monthIndex = date.getMonth();
            const monthName = months[monthIndex];
            const dayIndex = date.getDay()
            const dayName = days[dayIndex]
            tempPeakArr.push({ value: ele.date, label: ele.date });
          })
          setDropDate(tempPeakArr);          
        } else {
          setLoaderDisable(false);
          setDropDate([]);
          setAMdata([]);
          setMIDdata([]);
          setPMdata([]);
        }
      })
    }
    catch (error) {     
      setLoaderDisable(false);
    }
  }

  const getIntersectionDatePeakData = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getIntersectionDatePeakData,
        data: {
          stationId: props.stationId
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;      
          setTrafficCount(data);
          let tempPeakArr = [];
          let tempPeakValArr = [];
          data.map((val) => {
            let date = new Date(val.date);
            const monthIndex = date.getMonth();
            const monthName = months[monthIndex];
            const dayIndex = date.getDay()
            const dayName = days[dayIndex]
            tempPeakValArr.push(val.date);
            tempPeakArr.push({ value: val.date, label: val.date });
          });
          sessionStorage.getItem('intSelectedDate') ? setSelectedDate(sessionStorage.getItem('intSelectedDate')) : setSelectedDate(tempPeakValArr[0]);

          setDateVal(tempPeakValArr);
          setPeakDate(tempPeakArr);
          setDropDate(tempPeakArr)
          if (sessionStorage.getItem('intSelectedDate')) {
            data && data.length > 0 && data.map((val) => {
              if (val.date == sessionStorage.getItem('intSelectedDate')) {
                if (val.am) {
                  setAMdata(val.am);
                }
                if (val.mid) {
                  setMIDdata(val.mid);
                }
                if (val.pm) {
                  setPMdata(val.pm);
                }
              }
            })

            let resData = data.filter((value, index) => {            
              return value.date == sessionStorage.getItem('intSelectedDate');
            })
            disableTab(resData[0])
          } else {
            disableTab(data[0]);
            if (data && data[0] && data[0].am) {
              setAMdata(data[0].am);
            }
            if (data && data[0] && data[0].mid) {
              setMIDdata(data[0].mid);
            }
            if (data && data[0] && data[0].pm) {
              setPMdata(data[0].pm);
            }
          }

        }
        else {
          setSelectedDates([]);
          setDateVal([]);
          setPeakDate([]);
          setAMdata([]);
          setMIDdata([]);
          setPMdata([]);
        }
      })
    }
    catch (error) {
      console.log(error);
    }
  }


  const handleChangeDate = (event) => {
    sessionStorage.setItem('intSelectedDate', event.target.value);
    setSelectedDate(event.target.value);
    getTrafficCount && getTrafficCount.length > 0 && getTrafficCount.map((val) => {
      if (val.date == event.target.value) {
        if (val.am) {
          setAMdata(val.am);
        }
        if (val.mid) {
          setMIDdata(val.mid);
        }
        if (val.pm) {
          setPMdata(val.pm);
        }
      }
    })

    let resData = getTrafficCount.filter((value, index) => {     
      return value.date == event.target.value;
    })
    disableTab(resData[0])

  }

  const disableTab = (disableArr) => {
    if (disableArr.am.count === 0 && disableArr.mid.count === 0 && disableArr.pm.count === 0) {
      setAMDisabled(true);
      setMIDDisable(true);
      setPMDisabled(true);
    } else if (disableArr.am.count === 0 && (disableArr.mid.count !== 0 && disableArr.pm.count !== 0)) {
      sessionStorage.getItem('activeIntTrafficCountTab') && (sessionStorage.getItem('activeIntTrafficCountTab') == 1 || sessionStorage.getItem('activeIntTrafficCountTab') == 2) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeIntTrafficCountTab'))) : handleChangeIndex(1);
      setAMDisabled(true);
      setMIDDisable(false);
      setPMDisabled(false);
    } else if ((disableArr.am.count !== 0 && disableArr.mid.count !== 0) && disableArr.pm.count === 0) {
      sessionStorage.getItem('activeIntTrafficCountTab') && (sessionStorage.getItem('activeIntTrafficCountTab') == 0 || sessionStorage.getItem('activeIntTrafficCountTab') == 1) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeIntTrafficCountTab'))) : handleChangeIndex(0);
      setAMDisabled(false);
      setMIDDisable(false);
      setPMDisabled(true);
    } else if ((disableArr.am.count !== 0 && disableArr.pm.count !== 0) && disableArr.mid.count === 0) {
      sessionStorage.getItem('activeIntTrafficCountTab') && (sessionStorage.getItem('activeIntTrafficCountTab') == 0 || sessionStorage.getItem('activeIntTrafficCountTab') == 2) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeIntTrafficCountTab'))) : handleChangeIndex(0);
      setAMDisabled(false);
      setMIDDisable(true);
      setPMDisabled(false);
    } else if ((disableArr.am.count === 0 && disableArr.pm.count === 0) && disableArr.mid.count !== 0) {
      sessionStorage.getItem('activeIntTrafficCountTab') && (sessionStorage.getItem('activeIntTrafficCountTab') == 1) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeIntTrafficCountTab'))) : handleChangeIndex(1);
      setAMDisabled(true);
      setMIDDisable(false);
      setPMDisabled(true);
    }

    else if (disableArr.am.count !== 0 && (disableArr.mid.count === 0 && disableArr.pm.count === 0)) {
      sessionStorage.getItem('activeIntTrafficCountTab') && (sessionStorage.getItem('activeIntTrafficCountTab') == 0) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeIntTrafficCountTab'))) : handleChangeIndex(0);
      setAMDisabled(false);
      setMIDDisable(true);
      setPMDisabled(true);
    } else if ((disableArr.am.count === 0 && disableArr.mid.count === 0) && disableArr.pm.count !== 0) {
      sessionStorage.getItem('activeIntTrafficCountTab') && (sessionStorage.getItem('activeIntTrafficCountTab') == 2) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeIntTrafficCountTab'))) : handleChangeIndex(2);
      setAMDisabled(true);
      setMIDDisable(true);
      setPMDisabled(false);
    }    
    else {     
      setAMDisabled(false);
      setMIDDisable(false);
      setPMDisabled(false);
    }
  }

  return (
    <React.Fragment>
      <div className={classes.Intersection}>
        <p style={{ margin: 0 }}>Count Date &nbsp;
        {getDropDate && getDropDate.length > 0 ?
            <select className='trafficCountsSelect' value={getSelectedDate}
              onChange={(e) => { handleChangeDate(e) }}>
              {
                getDropDate.map((ele, index) => {
                  return (                    
                    <option value={ele.value} key={index} selected={sessionStorage.getItem('intSelectedDate') && sessionStorage.getItem('intSelectedDate') == ele.value ? true : false} >{ele.label}</option>
                  )
                })
              }
            </select> :

            <> <select className='trafficCountsSelect' style={{ width: "200px" }}>
              <option value=""></option>
            </select>

              {getDropDate && getDropDate.length > 0 ? <p style={{ textAlign: 'center' }}> No data has been imported for this station </p> : null} </>
          }
        </p>
        <div className={classes.root}>
          <AppBar position="static" color="default" className={classes.appBarMain}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >            
              <Tab className={getAMDisabled ? classes.tabDisable : null} label="AM" {...a11yProps(0)} id="am_Tab" disabled={getAMDisabled} />
              <Tab className={getMIDDisable ? classes.tabDisable : null} label="Mid" {...a11yProps(1)} id="mid_tab" disabled={getMIDDisable} />
              <Tab className={getPMDisabled ? classes.tabDisable : null} label="PM" {...a11yProps(2)} id="pm_tab" disabled={getPMDisabled} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabblock} style={{ height: sessionStorage.getItem('innerHeight') + 'px' }}>
              {AMdata && <AM AMdata={AMdata} stationId={props.stationId} />}
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabblock} style={{ height: sessionStorage.getItem('innerHeight') + 'px' }}>
              <Mid MIDdata={MIDdata} stationId={props.stationId} />
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction} className={classes.tabblock} style={{ height: sessionStorage.getItem('innerHeight') + 'px' }}>
              <PM PMdata={PMdata} stationId={props.stationId} />
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>

    </React.Fragment>
  );
}

export default IntersectionTrafficCounts;
//End IntersectionTrafficCounts component code ...